import angular from 'angular';
import ngTouch from 'angular-touch';
import ngSanitize from 'angular-sanitize';
import uiRouter from 'angular-ui-router';
import $ from '../vendor/js/jquery';
import 'bootstrap/js/tab';

import animations from './animations/animations';
import directives from './directives/directives';
import services from './services/services';
import filters from './filters/filters';

import '../vendor/js/jquery';
import '../vendor/js/jquery.meanmenu';
import '../vendor/js/jquery.elevatezoom';
import '../vendor/js/bootstrap3-typeahead';
import '../vendor/style/vendor.scss';
import '../vendor/style/animate.css';
import '../vendor/style/nivo-slider.css';
import '../vendor/style/nivo-slider.default.css';
import '../vendor/style/owl.carousel/owl.carousel.css';
import '../vendor/style/style.css';
import '../vendor/style/responsive.css';

import App from './views/app';
import appView from './views/app/index.html';

import AppHome from './views/app.home';
import appHomeView from './views/app.home/index.html';

import AppDetail from './views/app.detail';
import appDetailView from './views/app.detail/index.html';

import AppCategory from './views/app.category';
import appCategoryView from './views/app.category/index.html';

import AppSearch from './views/app.search';
import appSearchView from './views/app.search/index.html';

window.$ = $;

/**
 * Register main angular app
 */
export default angular.module('app', [
    ngTouch,
    ngSanitize,
    uiRouter,
    animations,
    directives,
    services,
    filters
])
    .config(function ($stateProvider, $locationProvider, $urlRouterProvider) {
        'ngInject';

        $stateProvider
            .state('app', {
                abstract: true,
                controller: App,
                template: appView
            })
            .state('app.home', {
                url: '/',
                controller: AppHome,
                template: appHomeView
            })
            .state('app.category', {
                url: '/categoria/:id-:url',
                controller: AppCategory,
                template: appCategoryView
            })
            .state('app.category-page', {
                url: '/categoria/:id-:url/:page',
                controller: AppCategory,
                template: appCategoryView
            })
            .state('app.search', {
                url: '/busca/:busca',
                controller: AppSearch,
                template: appSearchView
            })
            .state('app.search-page', {
                url: '/busca/:busca/:page',
                controller: AppSearch,
                template: appSearchView
            })
            .state('app.detail', {
                url: '/produto/:id-:url',
                controller: AppDetail,
                template: appDetailView
            });

        $urlRouterProvider.otherwise('/');
        
        $locationProvider.html5Mode(true);
    })
    .run(['$rootScope', '$http', '$timeout', '$state', function ($rootScope, $http, $timeout, $state) {
        $rootScope.frontURL = document.location.origin + '/';
        // $rootScope.frontURL = 'http://matrix.com.py/';
        $rootScope.backURL = $rootScope.frontURL;
        // $rootScope.backURL  = 'http://localhost:8080/';
        // $rootScope.backURL  = '//matrix-jhonnybail.c9users.io/';
        // $rootScope.backURL  = 'http://10.211.55.47/';
        // $rootScope.backURL = 'https://matrix.com.py/';
        $rootScope.showMenu = false;
        $rootScope.produtos = {};
        $rootScope.produto = null;
        $rootScope.categoria = null;
        $rootScope.search = {
            load: false
        };

        $rootScope.$state = $state;

        $rootScope.setProduto = function (produto) {
            $rootScope.produto = produto;
        };
        $rootScope.setCategoria = function (categoria) {
            $rootScope.categoria = categoria;
        };

        $rootScope.$on('$stateChangeStart', function (_evt, toState) {
            if (toState.name !== 'category' && toState.name !== 'category-page' && toState.name !== 'app.detail') {

                // document.title = 'Matrix - Eletrônicos e Informática';
                // $("meta[property='og:title']").attr('content', document.title);
                // $("meta[name='keywords']").attr('content', "matrix, paraguai, som automotivo, eletrônicos, receptores, celulares");
                // $("meta[name='description']").attr('content', "A loja mais completa de eletrônicos do Paraguai.");
            }
        });

        $http.get($rootScope.backURL + 'application/site/general').then(function (data) {

            $rootScope.cambio = data.data.cambio;
            $rootScope.produtosPorPagina = data.data.produtosporpagina;
            $rootScope.slides = data.data.slides;
            $rootScope.relampago = data.data.relampago;
            $rootScope.categorias = data.data.categorias;
            
            // Selecionar Categorias
            $rootScope.subCategorias = {};
            $rootScope.montaSubcategorias = function (categoria) {
                $rootScope.subCategorias[categoria.id] = [];
                $.each($rootScope.categorias, function (k, v) {
                    if (v.categoriapai && v.categoriapai.id === categoria.id && v.disponivel) {
                        $rootScope.subCategorias[categoria.id].push(v);
                    }
                });
            };
            $rootScope.hasSubCategorias = {};
            var categorias = [];

            $.each($rootScope.categorias, function (k, v) {
                if (v.imagem !== '' && (v.categoriapai === '' || v.categoriapai === null)) {
                    categorias.push(v);
                    $rootScope.montaSubcategorias(v);
                }
            });
            $.each(categorias, function (index, cat) {
                $.each($rootScope.categorias, function (k, v) {
                    if (v.categoriapai && v.categoriapai.id === cat.id && v.disponivel) {
                        $rootScope.hasSubCategorias[cat.id] = true;
                        return false;
                    }
                });
            });
            //
    
            $rootScope.catImagem = function (item) {
                return item.imagem !== '' && item.imagem !== null;
            };

            /* jQuery MeanMenu */
            $timeout(() => {
                $rootScope.$broadcast('onLoadGeneral');
            }, 100);
    
        }, function () {});

        $rootScope.configProduto = function (prod) {
            if (prod.valorreal === 0) {
                prod.estoque = 0;
                prod.valorvenda = 0;
            }
            return prod;
        };

    }])
    .name;



// WEBPACK FOOTER //
// ./src/app/app.js